export function scale(value, inMin, inMax, outMin, outMax) {
    return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
}

export function logScale(
    enteredValue,
    minEntry,
    maxEntry,
    normalizedMin,
    normalizedMax
) {
    var mx =
        Math.log2(enteredValue - minEntry) / Math.log2(maxEntry - minEntry);
    var preshiftNormalized = mx * (normalizedMax - normalizedMin);
    var shiftedNormalized = preshiftNormalized + normalizedMin;

    return shiftedNormalized;
}

export function getRandomInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
    spe;
}

export function getRandomRGBColor() {
    function getRandom(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    const r = getRandom(0, 255);
    const g = getRandom(0, 255);
    const b = getRandom(0, 255);

    return `rgb(${r}, ${g}, ${b})`;
}
